'use client';

import { AppBar, Box, Divider, Paper, Stack, Toolbar, Typography } from '@mui/material';
import React from 'react';
// Images
import Image from 'next/image';
import logo from './cardLogo.jpeg'

const FooterInfo = () => {
    return (
        <div>
            <Box sx={{ flexGrow: 1 }}>
                <Divider color="#07b259" sx={{ height:10 }} />
                <AppBar position="static">
                    <Toolbar sx={{ m:1 }}>
                            <Stack direction="row" spacing={1}>
                                <Image src={logo} alt="Logo" width={65} height={67} />
                                <Stack direction="column">
                                    <Typography>Corporate Headquarters</Typography>
                                    <Typography>11610 ASH STREET, SUITE 200</Typography>
                                    <Typography>LEAWOOD, KS 66211</Typography>
                                </Stack>
                            </Stack>
                            <Typography sx={{ flexGrow: 1 }} />
                            <Stack direction="column">
                                <Typography>PHONE: 1-800-444-4030</Typography>
                                <Typography>EMAIL: cashoutrequests@cimicard.com</Typography>
                            </Stack>
                            <Typography sx={{ flexGrow: 1 }} />
                            <Typography>CARD COMPLIANT, LLC COPYRIGHT © {new Date().getFullYear()}</Typography>
                    </Toolbar>
                </AppBar>
                <Divider color="#07b259" sx={{ height:10 }} />
            </Box>
        </div>
    )
}

export default FooterInfo;